interface Props {
    color?: string;
    scale?: number;
}

export const WavesOne = ({ color = 'black', scale = 1 }: Props) => {
    return (
        <svg
            width="100%"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 500 ${116 * scale}`}
        >
            <g transform={`scale(1, ${scale})`}>
                <path fill={color} d="M0 13.0001C0 13.0001 7.5 23.0001 51.5 23.0001C95.5 23.0001 122 0.391357 168.5 0.391357C215 0.391357 232 34.6703 281 34.6703C330 34.6703 345.5 13.8352 390.5 13.8352C435.5 13.8352 473.5 43.0001 500 43.0001C500 54 500 116 500 116H0V13.0001Z" fillOpacity="0.1"/>
                <path fill={color} d="M0 47C0 47 23 27 56 27C89 27 125.5 67 182 67C238.5 67 233.5 41.3396 272 41.3396C310.5 41.3396 308.5 73.4126 355.5 73.4126C402.5 73.4126 410 44.7236 442 44.7236C474 44.7236 500 67 500 67V116H0V47Z" fillOpacity="0.5"/>
                <path fill={color} d="M0 74C0 74 36.5 97 65.5 97C94.5 97 120.5 71.2002 149.5 71.2002C178.5 71.2002 200.5 110.206 232.5 110.206C264.5 110.206 274.5 89.1417 301 89.1417C327.5 89.1417 339 108.071 400.5 108.071C462 108.071 500 87 500 87V116H0V74Z"/>
            </g>
        </svg>
    )
}

export const WavesTwo = ({ color = 'black', scale = 1 }: Props) => {
    return (
        <svg
            width="100%"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 500 ${35 * scale}`}
        >
            <g transform={`scale(1, ${scale})`}>
                <path fill={color} d="M0 16.8889C0 16.8889 114.5 -21.1111 250 16.8889C385.5 54.8889 500 16.8889 500 16.8889V34.8889H0V16.8889Z"/>
            </g>
        </svg>
    )
}

export default WavesOne;
